import { removeQuery as i } from "../../temp-lib/util/query/index.js";
import { useRouter as R } from "next/router";
import * as t from "ramda";
import { useMemo as r, useCallback as p } from "react";
const I = (u) => {
  const f = R(), { asPath: d } = f, s = r(() => {
    const n = i(d);
    return n.endsWith("/") ? n : `${n}/`;
  }, [d]), o = p(
    (n) => t.pipe(
      t.toPairs,
      t.filter((a) => i(t.propOr("", "0", a)) === s),
      t.pathOr(!1, [0, 1, n])
    )(u),
    [s, u]
  ), m = r(() => o("noAskCookie"), [o]), P = r(() => o("noFullWidth"), [o]), N = r(() => o("noNavBar"), [o]), W = r(() => o("noHeader"), [o]), g = r(() => o("noIndex"), [o]), k = r(() => o("noFooter"), [o]), x = p(
    (n, e) => i(n) === s || t.map(i, e).includes(s),
    [s]
  ), C = p(
    (n) => {
      const e = t.split("/", s), a = t.find((h) => t.startsWith("?", h), e), O = (t.endsWith("/", s) ? 2 : 1) + (t.isNotNil(a) ? 1 : 0), v = t.isNotNil(a) ? t.remove(t.length(e) - 2, 1, e) : e, w = t.length(e) - O, c = t.split("/", n), l = t.find((h) => t.startsWith("?", h), c), F = (t.endsWith("/", n) ? 2 : 1) + (t.isNotNil(l) ? 1 : 0), y = t.propOr(
        "",
        String(t.length(c) - F),
        c
      ), Q = t.update(w, y, v);
      return t.join("/", Q) + (t.isNotNil(l) ? l : "");
    },
    [s]
  );
  return {
    cleanPath: s,
    noAskCookie: m,
    noFullWidth: P,
    noFooter: k,
    noHeader: W,
    noIndex: g,
    noNavBar: N,
    isCurrentPath: x,
    replacePath: C
  };
};
export {
  I as default
};
//# sourceMappingURL=usePath.js.map
